<template>
  <ul class="performance-metrics">
    <li
      v-for="metric in metrics"
      :key="metric.id"
      class="performance-metrics__item"
    >
      <span class="performance-metrics__label">{{ metric.label }}</span>
      <span class="performance-metrics__value">{{ metric.value }}</span>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export interface CampaignMetricDisplay {
  id: string;
  label: string;
  value: string;
}

export default defineComponent({
  name: 'CampaignPerformanceMetrics',
  props: {
    metrics: {
      type: Array as PropType<CampaignMetricDisplay[]>,
      required: true,
      default: () => [],
    },
  },
});
</script>

<style scoped lang="scss">
.performance-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.5rem 1rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.performance-metrics__item {
  display: flex;
  flex-direction: column;
}

.performance-metrics__label {
  color: var(--text-color-secondary, #6b7280);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.25rem;
}

.performance-metrics__value {
  font-weight: 600;
  font-size: 0.95rem;
}
</style>
